<template>
  <div class="yjtz-box">
    <div class="yjtz-content" v-if="data">
      <!-- 邮件信息卡片 -->
      <div class="yjtz-info-card">
        <div class="yjtz-info-left">
          <span class="yjtz-info-title">{{data.emailInfo.title}}</span>
          <span class="yjtz-info-desc">{{$t('all.shoujianren')}}：{{data.emailInfo.recipient}}</span>
        </div>
        <span class="yjtz-info-tag">{{$t('all.yifasong')}}</span>
      </div>
      <!-- 直播类型切换 -->
      <div class="yjtz-type-row">
        <div :class="data.liveType === 1 ? 'yjtz-type-active' : 'yjtz-type'" >{{$t('all.shoujizhibo')}}</div>
        <div :class="data.liveType === 2 ? 'yjtz-type-active' : 'yjtz-type'">OBS{{$t('all.zhibo')}}</div>
      </div>
      <!-- 邮件内容 -->
      <div class="yjtz-mail-card">
        <span class="yjtz-mail-title">{{data.emailInfo.statusTitle}}</span>
        <span class="yjtz-mail-desc" v-html="data.emailInfo.content.replace(/\n/g, '<br>')"></span>
      </div>
      <!-- 邮件编号 -->
      <div class="yjtz-item">
        <span class="yjtz-item-label">{{$t('all.youjianbianhao')}}</span>
        <span class="yjtz-item-value yjtz-text-green">{{data.emailInfo.emailNumber}}</span>
      </div>
      <!-- 重新发送按钮 -->
      <div class="yjtz-btn" @click="handleResend">{{$t('all.chongxinfasong')}}</div>
    </div>
  </div>
</template>

<script>
import { getLiveApplyInfo } from "@/api/zhiboshenqing";
export default {
  data() {
    return {
      liveType: 2,
	  data:'',
    };
  },
  mounted() {
    this.getLiveApplyInfo();
  },
  methods: {
	async getLiveApplyInfo(){
		const res = await getLiveApplyInfo({applyId:this.$route.query.applyId})
		this.data = res.data
	},
    handleResend() {
      this.$message.success(this.$t('all.caozuochenggong'));
    }
  }
};
</script>

<style scoped lang="scss">
@import "./youjiantongzhi.css";
</style>



// WEBPACK FOOTER //
// youjiantongzhi.vue?0a36d664